import type { Applog, CidString } from '@wovin/core'
import { encodeApplog, encodeApplogAndGetCid, WriteableThread } from '@wovin/core'
import { Logger } from 'besonders-logger'
import { defer } from 'lodash-es'
import { wovinApplogIDB } from '@wovin/utils'

export const appLogIDB = wovinApplogIDB('Note3_AppLogDB')

const { WARN, LOG, DEBUG, VERBOSE, ERROR } = Logger.setup(Logger.INFO, { prefix: '[db]' }) // eslint-disable-line unused-imports/no-unused-vars

export class ThreadIDB extends WriteableThread {
	constructor(name: string, applogs: Applog[] = [], filters: readonly string[] = []) {
		super(name, applogs, filters)
	}

	protected async persist(logs: Applog[]) {
		// when we get the cid, do we want to drop the pv and cid props
		// i mean what content do we want to address with this cid?
		defer(async () => {
			DEBUG(`[IDB.persist] persisting`, logs)
			if (localStorage.getItem('note3.dev.noPersist')) {
				// @ts-expect-error
				if (!this.noPersistWarned) {
					WARN(`Persistence is DISABLED via localStorage:'note3.dev.noPersist'`, this)
					// @ts-expect-error
					this.noPersistWarned = true
				}
				return DEBUG(`[IDB.persist] noPersist`)
			}
			appLogIDB.applogs.bulkPut(
				await Promise.all(logs.map(async (eachLog) => {
					const cid = (encodeApplogAndGetCid(eachLog)).toString() // TODO: skip if existing - if we're sure this ain't happening:
					if (eachLog.cid && eachLog.cid !== cid) {
						ERROR(`In-mem CID is different than when persisting`, { eachLog, cid, encoded: encodeApplog(eachLog) })
					}
					return ({ ...eachLog, cid })
				})),
			)
		})
	}

	public async delete(logs: CidString[]) {
		// needs to sync idb and internal inmemory array state
		defer(async () => {
			DEBUG(`[IDB.delete] deleteing`, logs)
			if (localStorage.getItem('note3.dev.noPersist')) {
				// @ts-expect-error
				if (!this.noPersistWarned) {
					WARN(`Persistence is DISABLED via localStorage:'note3.dev.noPersist'`, this)
					// @ts-expect-error
					this.noPersistWarned = true
				}
				return DEBUG(`[IDB.delete] noPersist`)
			}
			await appLogIDB.applogs.bulkDelete(logs)
		})
	}

	get readOnly() {
		return false
	}
}

export async function deleteAllApplogs({ sure }: any) {
	if (sure !== 'I am') {
		throw ERROR(`[deleteAllApplogs] but not sure?!`)
	} else {
		await appLogIDB.applogs.clear()
	}
}
